/* eslint-disable camelcase */
/**
* token
*/
export const USER_TOKEN = 'PONHU_WEBAPP_USERTOKEN'

/**
* 用户信息
*/
export const USER_INFO = 'PONHU_WEBAPP_USERINFO'

/**
* 用户微信OpenID
*/
export const USER_OPENID = 'PONHU_WEBAPP_OPENID'

/**
* 用户结算信息
*/
export const USER_BALANCE_INFO = 'PONHU_WEBAPP_USER_BALANCE_INFO'
/**
* 用户线上结算信息
*/
export const USER_ONLINE_BALANCE_INFO = 'PONHU_WEBAPP_USER_ONLINE_BALANCE_INFO'
/**
* 用户编辑地址
*/
export const EDIT_ADDRESS = 'PONHU_WEBAPP_EDIT_ADDRESS'

/**
* 设配信息
*/
export const SYSTEM_INFO = 'PONHU_WEBAPP_SYSTEMINFO'

/**
* 平台渠道
*/
export const PlATFORM_CHANNEL = 'PONHU_PlATFORM_CHANNEL'

/**
*  省市区数据
*/
export const DEFAULT_AREA_LIST = 'PONHU_WEBAPP_DEFAULT_AREA_LIST'
/**
*  省市区数据
*/
export const DEFAULT_AREA_LISTCHILDREN = 'PONHU_WEBAPP_DEFAULT_AREA_LISTCHILDREN'
/**
*  商品分类
*/
export const BASE_CATEGORY = "PONHU_WEBAPP_CATEGORY";
/**
 * 品牌分类
 */
export const BASE_BRAND = "PONHU_WEBAPP_BRAND"
/**
*  排序
*/
export const BASE_SORT = "PONHU_WEBAPP_SORT";
/**
 * 价格
 */
export const BASE_PRICE = "PONHU_WEBAPP_PRICE"
/**
 * 适用人群
 */
export const BASE_PEOPLE = "PONHU_WEBAPP_PEOPLE"
/**
 * 成色
 */
export const BASE_CHANGE = "PONHU_WEBAPP_CHANGE"
/**
 * APP渠道
 */
export const APP_CHANNEL_ID = "PONHU_APP_CHANNEL_ID"
/**
* userPhone
*/
export const USER_PHONE = 'PONHU_WEBAPP_USERPHONE'
